import { render, staticRenderFns } from "./PageTx.vue?vue&type=template&id=0318e218"
import script from "./PageTx.vue?vue&type=script&lang=js"
export * from "./PageTx.vue?vue&type=script&lang=js"
import style0 from "./PageTx.vue?vue&type=style&index=0&id=0318e218&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports